export default __webpack_public_path__ + "static/media/5.8678d638.png";